import { EntityRequestAprv } from "../../entity/EntityRequestAprv";

export class DtoRequestAprvsDeleteRes extends EntityRequestAprv {
  public message: string | null = null;
}
